import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { invPaymentAdjustOrFeeInit } from "utils/HelperInvoicePayment";
import CurrencyInput from "react-currency-input-field";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { useInvoicePaymentModalFormContext } from "contexts/invoicePage/InvoicePaymentModalFormContext";
import { nanoid } from "@reduxjs/toolkit";
export default function InvoicePaymentAdjustOrFee(param) {
    var paymentIndex = param.paymentIndex;
    var _form_factNewInvAdjustmentOrFee;
    var _useInvoicePaymentModalFormContext = useInvoicePaymentModalFormContext(), form = _useInvoicePaymentModalFormContext.form, formHandlerState = _useInvoicePaymentModalFormContext.formHandlerState, errors = _useInvoicePaymentModalFormContext.errors;
    var setFieldForm = formHandlerState.setFieldForm, addArrayItem = formHandlerState.addArrayItem, removeArrayItem = formHandlerState.removeArrayItem;
    var options = useInvoiceInitContext().options;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            form === null || form === void 0 ? void 0 : (_form_factNewInvAdjustmentOrFee = form.factNewInvAdjustmentOrFee) === null || _form_factNewInvAdjustmentOrFee === void 0 ? void 0 : _form_factNewInvAdjustmentOrFee.map(function(item, index) {
                var _form_factNewInvAdjustmentOrFee_index, _form_factNewInvAdjustmentOrFee_index1;
                var adjustOrFeePath = "factNewInvAdjustmentOrFee[".concat(index, "].dim_mst_adjust_or_fee_id");
                var isAdjustOrFeeInvalid = !get(form, adjustOrFeePath) && !!get(errors, adjustOrFeePath);
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ _jsx("fieldset", {
                                className: "col-8",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "row ",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-1 flex items-center",
                                            children: index + 1
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                        className: "mb-1",
                                                        children: [
                                                            "ปรับปรุง",
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "tc-16",
                                                                children: "*"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        as: "select",
                                                        name: "factNewInvAdjustmentOrFee[".concat(index, "].dim_mst_adjust_or_fee_id"),
                                                        placeholder: "เลือกการปรับปรุง",
                                                        onChange: function(e) {
                                                            setFieldForm("factNewInvAdjustmentOrFee[".concat(index, "].dim_mst_adjust_or_fee_id"), e.value);
                                                        },
                                                        className: "w-100 select-st-1 ".concat(isAdjustOrFeeInvalid ? "is-invalid" : ""),
                                                        options: options.adjustOrFee,
                                                        value: options.adjustOrFee.filter(function(d) {
                                                            return d.value == item.dim_mst_adjust_or_fee_id;
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "จำนวนเงินที่ชำระ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(CurrencyInput, {
                                                        placeholder: "",
                                                        defaultValue: ((_form_factNewInvAdjustmentOrFee_index = form.factNewInvAdjustmentOrFee[index]) === null || _form_factNewInvAdjustmentOrFee_index === void 0 ? void 0 : _form_factNewInvAdjustmentOrFee_index.price) || 0,
                                                        value: ((_form_factNewInvAdjustmentOrFee_index1 = form.factNewInvAdjustmentOrFee[index]) === null || _form_factNewInvAdjustmentOrFee_index1 === void 0 ? void 0 : _form_factNewInvAdjustmentOrFee_index1.price) || 0,
                                                        decimalsLimit: 2,
                                                        // fixedDecimalLength={2}
                                                        decimalScale: 2,
                                                        onValueChange: function(value, name, values) {
                                                            setFieldForm("factNewInvAdjustmentOrFee[".concat(index, "].price"), value);
                                                        },
                                                        className: "form-control formv text-end me-2"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col",
                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                className: "mb-2 form-st-3 pb-1",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                        className: "mb-1",
                                                        children: "หมายเหตุ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "factNewInvAdjustmentOrFee[".concat(index, "].remark"),
                                                        className: "form-control",
                                                        placeholder: "กรอกหมายเหตุ",
                                                        value: item.remark,
                                                        onChange: function(e) {
                                                            return setFieldForm("factNewInvPaymentRow[".concat(index, "].remark"), e.currentTarget.value);
                                                        },
                                                        isInvalid: !!get(errors, "factNewInvAdjustmentOrFee[".concat(index, "].remark"))
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: " col-auto align-self-center",
                                children: /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-delete-st-n1",
                                    onClick: function() {
                                        return removeArrayItem("factNewInvPaymentRow", index);
                                    }
                                })
                            })
                        ]
                    })
                }, index);
            }),
            /*#__PURE__*/ _jsx("button", {
                className: "btn-st-3 btn mt-2",
                type: "button",
                onClick: function() {
                    addArrayItem("factNewInvAdjustmentOrFee", _object_spread_props(_object_spread({}, invPaymentAdjustOrFeeInit), {
                        id: nanoid()
                    }));
                },
                children: "+ ค่าธรรมเนียม หรือ รายการปรับปรุง"
            })
        ]
    });
}
